<template>
  <div :style="`height: ${size + label ? 40 : 0}px; width: ${size}px;`">
    <div v-if="label" class="overline width100p text-center">
      {{ label }}
    </div>
    <div class="maddoxContainer" :style="maddoxContainerStyle">
      <img :src="degreeImage" alt="degree" class="degreeImage" />
      <div class="circle frame"></div>
      <div
        class="maddox circle"
        :class="color == 'white' ? 'white' : 'red'"
        :style="rotateStyle"
      ></div>
      <div class="reflection"></div>
      <rotate-slider
        class="sliderClass"
        :size="size"
        :noButtons="true"
        :min="45"
        :max="135"
        @valChange="valChange($event)"
      />
      <div class="text-center bottomText">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import RotateSlider from "./RotateSlider.vue";

export default {
  name: "Maddox",
  components: {
    RotateSlider,
  },
  props: {
    color: {
      type: String,
      default: "red", // red or white
    },
    size: {
      type: Number,
      default: 200,
    },
    label: String,
  },
  data: function () {
    return {
      angle: 90,
      degreeImage: "https://www.eyedock.com/images/crosses/degree%20dial.svg",
    };
  },
  methods: {
    valChange(val) {
      this.angle = val;

      //   this.$emit("valChange", val);
    },
  },
  computed: {
    maddoxContainerStyle: function () {
      return {
        width: this.size + "px",
        height: this.size + "px",
      };
    },
    rotateStyle: function () {
      //   console.log(this.angle);
      let style = "transform: translate(-50%, -50%) ";
      style += `rotate(${90 - this.angle}deg);`;
      //   console.log(style);
      return style;
    },
  },
  watch: {
    angle() {
      this.$emit("valChange", this.angle);
    },
  },
};
</script>

<style scoped>
.maddoxContainer {
  position: relative;
  /* border: 4px solid green; */
  /* background-color: #000000; */
}
.circle {
  transform: translate(-50%, -50%);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  position: absolute;
}
.frame {
  width: 75%;
  height: 75%;
  background-color: #c1c1c1;
  box-shadow: inset 0px -3px 7px 2px #00000030, inset 1px 2px 3px 2px #ffffff8f;
}
.maddox {
  width: 55%;
  height: 55%;
  box-shadow: inset 0px 0px 5px 3px #00000057;
}
.red {
  background-image: repeating-linear-gradient(
    90deg,
    #ff9393ff 0%,
    rgb(155, 0, 0) 7%,
    #ff9393ff 14%
  );
}
.white {
  background-image: repeating-linear-gradient(
    90deg,
    rgb(255, 255, 255) 0%,
    rgb(167, 167, 167) 7%,
    rgb(255, 255, 255) 14%
  );
}

.reflection {
  position: absolute;
  transform: translate(-50%, -50%);
  width: 31%;
  height: 17%;
  background-color: #ffffff;
  opacity: 0.3;
  top: 37%;
  left: 50%;
  border-radius: 50%;
  filter: blur(5px);
}
.sliderClass {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
}

.degreeImage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 112%;
  height: 107%;
}
.bottomText {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
